//import showView from "../views/index";
//import AppEvent from '../helpers/appEvent'
import { Config } from "../core/config"
import urlHelper from '../helpers/url';

const yaTiene = () => {
    urlHelper.redirect(Config.dominioMiCuenta + "/mis-suscripciones");
    //TODO: Hacer andar el modal de deuda en Paywall
    //showView('TIENE_DEUDA')
    //AppEvent.sendEvent('TIENE_DEUDA');
}

export default yaTiene;


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/controllers/tieneDeuda.js